import { defineComponent, ref, Ref, computed, onMounted, onUnmounted } from 'vue';
import { MessageModel } from '@truckdown/systems';
import { Constants } from '../../constants';

import { default as context } from '../../main';

interface Message extends MessageModel {
    id: string;
}

interface IData {
    message: Ref<Message | undefined>
}

const getData = function () {
    return {
        message: ref<Message | undefined>()
    } as IData;
}

const getComputed = function (data: IData) {
    return {
        showMessage: computed(() => {
            return data.message.value ? true : false;
        }),
        showLink: computed(() => {
            return data.message.value && data.message.value.link ? true : false;
        })
    };
}

const getMethods = function (data: IData) {
    return {
        dismiss: function () {
            data.message.value = undefined;
        }
    };
}

const showMessage = function (data: IData, id: string, message: MessageModel) {
    try {
        if (id && message) {
            let res = message as Message;
            res.id = id;
            data.message.value = res;
        }
    }
    catch (err) {
        console.log(err);
    }
}

const handleMessageClick = function (data: IData, id: string, message: MessageModel) {
    try {
        if (id && message) {
            if (message.link) {
                window.location.href = message.link;
            } else {
                showMessage(data, id, message);
            }
        }
    }
    catch (err) {
        console.log(err);
    }
}

export default defineComponent({
    name: 'notification-component',
    inheritAttrs: false,
    setup: function () {
        let data = getData();
        let computed = getComputed(data);
        let methods = getMethods(data);

        const receiveMessage = function (id: string, message: MessageModel) {
            showMessage(data, id, message);
        };

        const clickMessage = function (id: string, message: MessageModel) {
            handleMessageClick(data, id, message);
        };

        const dimissMessage = function (id: string) {
            if (data.message.value && id == data.message.value.id) {
                methods.dismiss();
            }
        };

        onMounted(() => {
            if (context.isAuthenticated) {
                context.events.on(Constants.Events.NotificationReceived, receiveMessage);
                context.events.on(Constants.Events.NotificationDismissed, dimissMessage);
                context.events.on(Constants.Events.NotificationClicked, clickMessage);
            }

        });

        onUnmounted(() => {
            context.events.off(Constants.Events.NotificationReceived, receiveMessage);
            context.events.off(Constants.Events.NotificationDismissed, dimissMessage);
            context.events.off(Constants.Events.NotificationClicked, clickMessage);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});